<template>
  <div>
    <vm-table
        ref="vmTable"
        height="50vh"
        :filter.sync="filter"
        module="basic"
        url="sd/so/selectZaiYongTiAmount"
        @select="selectHandle"
        @select-all="selectHandle">
      <div slot="toolbar">
        <el-button type="primary" @click="buyListDownLoadFile()">导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="计划开始日期">
            <el-date-picker
                v-model="filter.beginFinalDeliveryDate"
                value-format="yyyy-MM-dd"/>
          </vm-search>
          <vm-search label="至">
            <el-date-picker
                v-model="filter.endFinalDeliveryDate"
                value-format="yyyy-MM-dd"/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="outFactoryNO" align="center" width="200" label="区域"/>
      <el-table-column prop="employeeName" align="center" width="200" label="销售名称"/>
      <el-table-column prop="customerName" align="center" width="200" label="客户名称"/>
      <el-table-column prop="techParamBillNO" align="center" width="200" label="订单编号"/>
      <el-table-column prop="sapsaleOrderNO" align="center" width="200" label="SAP销售订单"/>
      <el-table-column prop="clientContractNO" align="center" width="200" label="客户合同号"/>
      <el-table-column prop="totalMoney" align="center" width="200" label="总价"/>
      <el-table-column
          label="操作"
          align="center"
          fixed="right"
          class-name="vm-table_operate"/>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import yiXinApplicationEdit from "@/views/salesManage/yiXinShipmentApplication/yiXinApplicationEdit";

  export default {
    name: "ZaiYongTiAmount",
    components: {VmTable, VmSearch},
    data() {
      return {
        selection: [],
        filter: {
          beginFinalDeliveryDate: "",
          endFinalDeliveryDate: "",
        },
      };
    },
    mounted() {
      this.initTime();
      this.$refs.vmTable.getList(1);
    },
    methods: {

      getList(pageNum) {
        if (this.filter.beginFinalDeliveryDate === "" || this.filter.endFinalDeliveryDate === "") {
          this.$message.error("请先选择日期");
        }

        this.$refs.vmTable.getList(pageNum);
      },

      initTime() {
        this.filter.endFinalDeliveryDate = this.getFormatDate(new Date());
        this.filter.beginFinalDeliveryDate = this.getFormatDate1(new Date(new Date() - 3600 * 1000 * 24 * 29));
      },

      getFormatDate(date) {
        var month = date.getMonth() + 1;
        // var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        // if (strDate >= 0 && strDate <= 9) {
        //   strDate = "0" + strDate;
        // }
        return date.getFullYear() + "-" + month + "-" + 25;
      },
      getFormatDate1(date) {
        var month = date.getMonth() + 1;
        // var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        // if (strDate >= 0 && strDate <= 9) {
        //   strDate = "0" + strDate;
        // }
        return date.getFullYear() + "-" + month + "-" + 26;
      },


      selectHandle(selection) {
        this.selection = selection;
      },

      //下载清单
      buyListDownLoadFile() {
        this.downloadLoading = true;
        this.$http
            .exportFile("basic", "sd/so/exportZaiYongTiAmount", this.filter)
            .then((resp) => {
              let blob = new Blob([resp.data]);
              let fileName = decodeURI(resp.headers.filename);
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, fileName);
              } else {
                let a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = fileName;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
              }
              this.downloadLoading = false;
            })
            .catch(() => {
              this.downloadLoading = false;
            });
      },


    },
  };
</script>
<style lang="scss" scoped>
</style>
